<template>
  <div class="nodata-box">
    <img :src="siteConfig.noData" alt="">
    <span>{{ text || $t('noData') }}</span>
  </div>
</template>

<script>
export default {
  name: 'no-data',
  props: {
    text: String
  }
};
</script>

<style lang="scss" scoped>
.nodata-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  margin-top: 15px;
  img {
    width: 80px;
    height: auto;
  }

  span {
    margin-top: 16px;
    font-family: 'PingFang SC';
    font-size: 14px;
    line-height: 14px;
    color: rgba(215, 215, 215, 0.7);
  }
}
</style>
